import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from 'ttag';

import { FeedFilterTitle } from '@components/FeedFilterTitle';

export default class ConditionFilter extends Component {
  state = {
    isActive: true,
  };

  handleToggle = () => {
    this.setState({ isActive: !this.state.isActive });
  };

  handleConditionChanged = (id) => {
    this.props.eventStream.next({
      action: 'setConditionFilter',
      id,
    });
  };

  render() {
    const cls = classNames({
      'b-filter__section': true,
      'b-filter__section_state_active': this.state.isActive,
    });

    return (
      (<div className={cls}>
        <FeedFilterTitle
          title={t`Стан`}
          hide={!this.state.isActive}
          onClick={this.handleToggle}
        />
        <ul className="b-filter__content b-simple-list">
          {
            this.props.filters.map((filter) => {
              const isChecked = this.props.checked.includes(filter.id);
              return (
                <li key={filter.id} className="b-simple-list__item">
                  <input
                    type="checkbox"
                    id={`used-${filter.id}`}
                    className="b-form-check-input"
                    checked={isChecked}
                    onChange={() => this.handleConditionChanged(filter.id)}
                  />
                  <label
                    htmlFor={`used-${filter.id}`}
                    className="b-form-checkbox"
                  >
                    {filter.name}
                  </label>
                </li>
              );
            })
          }
        </ul>
      </div>)
    );
  }
}

ConditionFilter.propTypes = {
  filters: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
};
